import React from 'react'
import Card from 'react-bootstrap/Card';
import Image from 'react-bootstrap/Image';
import Button from 'react-bootstrap/Button';
import PropTypes from 'prop-types';

const MobileView = ({ test, image, clockIcon }) => {
    return (
        <Card.Body>
            <div className="container-fluid">
                <div className="row d-flex flex-row">
                    <div className="col-12 col-sm-12 d-flex justify-content-center text-center px-0">
                        <div className="col-12 d-flex flex-column">
                            <span className='action-required-title'>{test?.test?.type_name}</span>
                            <span className='action-required-status gap-2 ageo-semibold'><span className='text-muted'>Status:</span> Action required <img src={clockIcon} alt="Clock Icon" /></span>
                            <span className="action-required-description">Your test registration is incomplete, if your sample is collected, click the button below to register it now.</span>
                        </div>
                    </div>
                </div>
                <div className="row mt-3">
                    <div className="col-12 d-flex align-items-center justify-content-center px-0">
                        <Button href={`/${test?.test?.detail_link}/resume/${test?.test?.id}/`} className="w-100">Complete registration</Button>
                    </div>
                </div>
            </div>
        </Card.Body>
    )
}

MobileView.propTypes = {
    test: PropTypes.shape({
        test: PropTypes.shape({
            type_name: PropTypes.string.isRequired,
            detail_link: PropTypes.string.isRequired,
            id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
        }).isRequired,
    }).isRequired,
    image: PropTypes.string.isRequired,
    clockIcon: PropTypes.string.isRequired,
};

export default MobileView